import _ from 'lodash';
import moment from 'moment-timezone'


// const getLineError = (state) => (index) =>{
//   if(state.reservation.details[index].errors != null){
//     return state.reservation.details[index].errors.jse_info.errorCode;
//   }
//   return "";
// }
//
// const contacts = (state) =>{
//   if(state.reservation.customer!=null){
//     if(state.reservation.customer.company!=null){
//       return _.filter(state.reservation.customer.company.contacts, c=> c.active === true);
//     }else{
//       return [state.reservation.customer.contact];
//
//     }
//   }else{
//     return [];
//   }
//
// }


// const isCommentRequired = (state) => (index) =>{
//   if(state.reservation.details[index].errors != null){
//     return state.reservation.details[index].errors.jse_info.errorCode==="BOIRES_RESERVATION_120_DAYS";
//   }
//   return false
// }
// const getCustomerReservationsByDate = (state) =>{
//   return _.groupBy(state.customerReservations,"date")
// }
//
// const getCustomerReservationsByProduct = (state) =>{
//   return _.groupBy(state.customerReservations, "product.name")
// }

export default {
  // getLineError,
  // isCommentRequired,
  // contacts
};
